import React, { useEffect, useState } from "react";  
import { useSelector, useDispatch } from 'react-redux'
import * as Admin from "../../store/ducks/admin.duck";
import * as Auth from "../../store/ducks/auth.duck";
import { Card, Modal } from "react-bootstrap";
import '../../../_metronic/_assets/css/app2.css';
import UpdatePassword from '../../components/UpdatePassword'
import { ToastContainer, Flip } from "react-toastify";

export default function DashboardPsychiatrist() {
  
  const dispatch = useDispatch()
  const isRecovery = useSelector(state => state.auth.recoveryStatus)
  const [showUpdatePassword, setShowUpdatePassword] = useState(false)
  useEffect( () => { dispatch(Admin.actions.fetchReferrers()) }, [dispatch] )
  
  useEffect( () => {
    if (isRecovery === 'Recovery') {
      dispatch(Auth.actions.clearRecovery())
      setShowUpdatePassword(true)
    }
  }, [dispatch,isRecovery])

  // useEffect( () => { dispatch(Admin.actions.fetchCsAgent()) }, [dispatch] )
  // // now init the fields with values so that Formik can manage the touched state
  // const centralisedServiceInit = {
  //   firstname: '', 
  //   surname: '', 
  //   email: '', 
  //   mobilephone: '',
  //   timezone: 'AUS Eastern Standard Time',
  //   newpassword: '',
  //   newpasswordconfirmation: '',
  //   id : 0,
  // }
  // // get the Centralised Service records and merge with the initialised fields
  // var centralisedServiceState = useSelector(state =>  state.admin.CsAgent);
  // var centralisedService = {...centralisedServiceInit, ...centralisedServiceState};


  return (
    <>
      <div className="row" style={{ marginBottom: 20 }}>
        <div className="col-xl-12">
        <Card style={{ marginRight: 20 }}>
          <Card.Body className="welcome-bg">
            <Card.Title>Welcome to the new Medicare Mental Health Centres Tele-psychology and Tele-psychiatry Centralised Service</Card.Title>
          </Card.Body>
        </Card>
      </div>
    </div>

    <ToastContainer
      position="bottom-right"
      transition={Flip}
      autoClose={5000}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />    

    <Modal show={showUpdatePassword} onHide={()=>setShowUpdatePassword(false)} dialogClassName="todos-modal-dialog">
      <Modal.Header closeButton className="todos-modal">
        <Modal.Title>You have recently recovered your password, please update your password</Modal.Title>
      </Modal.Header>
      <Modal.Body className="todos-modal">
        <UpdatePassword setShowUpdatePassword={setShowUpdatePassword} />
      </Modal.Body>
    </Modal>
  </>
  )

}
